module.exports = __webpack_public_path__ + "static/media/photo-reservist.84855b8c.svg";